/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Component, PropsWithChildren } from 'react';
import colors from '../colors';

export class TableTitleHeader extends Component<PropsWithChildren> {
  render() {
    const { children } = this.props;
    return (
      <span
        css={css(`
          color: ${colors.highlight};
          font-size: 16px;
          font-weight: bold;
        `)}
      >
        {children}
      </span>
    );
  }
}
